export const VOLUME_CONVERSION = [{
        id: 1,
        value: 'teaspoon',
        multiplier: 4.92892,
        unit: 'ml'
    },
    {
        id: 2,
        value: 'tablespoon',
        multiplier: 14.7868,
        unit: 'ml'
    },
    {
        id: 3,
        value: 'ounce',
        multiplier: 29.5735,
        unit: 'ml'
    },
    {
        id: 4,
        value: 'cup',
        multiplier: 236.588,
        unit: 'ml'
    },
    {
        id: 5,
        value: 'pint',
        multiplier: 473.176,
        unit: 'ml'
    },
    {
        id: 6,
        value: 'quart',
        multiplier: 0.946353,
        unit: 'litre'
    },
    {
        id: 7,
        value: 'gallon',
        multiplier: 3.78541,
        unit: 'litre'
    },
]


export const WEIGHT_CONVERSION = [{
        id: 1,
        value: 'ounce',
        multiplier: 28.3495,
        unit: 'g'
    },
    {
        id: 2,
        value: 'pound',
        multiplier: 0.4536,
        unit: 'kg'
    },
    {
        id: 3,
        value: 'stone',
        multiplier: 6.35029,
        unit: 'kg'
    },
    {
        id: 4,
        value: 'ton',
        multiplier: 907.184,
        unit: 'kg'
    },
]

export const LENGTH_CONVERSION = [{
        id: 1,
        value: 'inch',
        multiplier: 2.54,
        unit: 'cm'
    },
    {
        id: 2,
        value: 'foot',
        multiplier: 30.48,
        unit: 'cm'
    },
    {
        id: 3,
        value: 'yard',
        multiplier: 91.44,
        unit: 'cm'
    },
    {
        id: 4,
        value: 'mile',
        multiplier: 1.609,
        unit: 'km'
    }
]

export const TEMPERATURE_CONVERSION = [{
    id: 1,
    value: '°F',
    substract: 32,
    multiplier: 0.55555,
    unit: '°C'
}]